import styled from "styled-components";

export const Nav = styled.nav`
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
  gap: 0;
`;

interface PageButtonProps {
  $active?: boolean;
}

export const PageButton = styled.button<PageButtonProps>`
  background-color: ${({ $active }) => ($active ? "#ec6726" : "#eee")};
  color: ${({ $active }) => ($active ? "#fff" : "#ec6726")};
  font-weight: bold;
  font-size: 14px;
  margin: 0;
  padding: 10px 12px;
  border: none;
  text-align: center;
  transition: background-color 0.3s, color 0.3s;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover:not(:disabled) {
    background-color: ${({ $active }) => ($active ? "#ec6726" : "#f3953f")};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  @media (max-width: 600px) {
    font-size: 11px;
    padding: 8px 10px;
  }
`;

export const Ellipsis = styled.span`
  background-color: #eee;
  color: #ec6726;
  font-weight: bold;
  font-size: 14px;
  padding: 10px 12px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 600px) {
    font-size: 11px;
    padding: 8px 10px;
  }
`;
